// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"_2qSfJhME-Orc","modal":"L-Z65FcxMPDs","scrollPaper":"eLk2omVf1Nvu"};